<template>
	<div class="container">
		<div class="content">
			<div v-if="mode === 'list'" class="card">
				<h3 class="title mb_16">
					{{ $t('rtr_activity-exchange.title1') }}
				</h3>
				<div class="mb_16">
					<div class="d_flex align_items_end mb_10">
						<div class="info mr_10">
							<date-picker
								is-required
								v-model="startDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
						<div class="info">
							<date-picker
								is-required
								v-model="endDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
					</div>
					<div class="d_flex">
						<div class="select_area">
							<select
								v-model="assetSeq"
								class="asset_area"
								@change="loadDirectTransferList('pageInit')"
							>
								<option :value="null">
									{{ $t('input.placeholder.all_assets') }}
								</option>
								<option
									v-for="item in accounts"
									:key="item.seq"
									:value="item.asset_seq"
								>
									{{ item.asset_title }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</div>
				</div>
				<ul class="tab_area mb_8">
					<li
						:class="[{ selected: selectedTab === 'ALL' }, 'all']"
						@click="selectedTab = 'ALL'"
					>
						<a>{{ $t('rtr_activity-exchange.tab1') }}</a>
					</li>
					<li
						:class="[{ selected: selectedTab === 'BID' }, 'buy']"
						@click="selectedTab = 'BID'"
					>
						<a>{{ $t('rtr_activity-exchange.tab2') }}</a>
					</li>
					<li
						:class="[{ selected: selectedTab === 'ASK' }, 'sell']"
						@click="selectedTab = 'ASK'"
					>
						<a>{{ $t('rtr_activity-exchange.tab3') }}</a>
					</li>
				</ul>

				<div v-if="accountTransferList.length === 0" class="list_none">
					<span class="ERRORGRAY"></span>
					<p>{{ $t('rtr_activity-exchange.empty') }}</p>
				</div>

				<div v-else class="list">
					<!-- li 부터 한뭉탱이 -->
					<ul>
						<li v-for="item in accountTransferList" :key="item.seq">
							<div class="list_item_box">
								<div class="list_item d_flex justify_between mb_4">
									<p class="fs_14">
										{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
									</p>
									<div v-if="item.transfer_type === 'BID'">
										<span class="label_buy">{{
											$t('rtr_activity-exchange.buy')
										}}</span>
									</div>
									<div v-else>
										<span class="label_sell">{{
											$t('rtr_activity-exchange.sell')
										}}</span>
									</div>
								</div>
								<div class="list_item mb_4">
									<p v-if="item.transfer_type === 'BID'">
										{{ $t('rtr_activity-exchange.detail.th3') }}
									</p>
									<p v-else>{{ $t('rtr_activity-exchange.detail.th13') }}</p>
									<div class="num_unit type01">
										<p class="num">{{ item.source_amount }}</p>
										<p class="unit">{{ item.source_asset_code }}</p>
									</div>
								</div>
								<div class="d_flex align_items_end justify_between">
									<div class="list_item">
										<p>{{ $t('rtr_activity-exchange.th4') }}</p>
										<div class="num_unit type01">
											<p class="num">{{ item.target_amount }}</p>
											<p class="unit">{{ item.target_asset_code }}</p>
										</div>
									</div>
									<div class="list_item">
										<div class="btn_area">
											<button class="button_bg_black" @click="showDetail(item)">
												{{ $t('button.detail') }}
											</button>
										</div>
									</div>
								</div>
							</div>
							<Accordion>
								<AccordionItem2>
									<template v-slot:accordion-trigger>
										<span class="accordion_trigger_icon"></span>
									</template>
									<template v-slot:accordion-content>
										<div class="accordion_border body_l">
											<div class="list_item">
												<p>{{ $t('rtr_activity-exchange.th5') }}</p>
												<p>{{ item.basic_rate }}</p>
											</div>
											<div class="list_item">
												<p>{{ $t('rtr_activity-exchange.th6') }}</p>
												<p>{{ item.spread_rate }}</p>
											</div>
											<div class="list_item">
												<p>{{ $t('rtr_activity-exchange.th7') }}</p>
												<p>{{ item.exchange_rate }}</p>
											</div>
										</div>
									</template>
								</AccordionItem2>
							</Accordion>
						</li>
					</ul>
				</div>
				<pagination
					:totalCount="pageNavigation.total_count"
					:totalPage="pageNavigation.total_page"
					:curPage="pageNavigation.cur_page"
					:point="pageNavigation.point"
					:firstPage="pageNavigation.first_page"
					:lastPage="pageNavigation.last_page"
					@change="pageChangeHandler"
				></pagination>
			</div>
			<ExchangeDetailM
				v-if="mode === 'detail'"
				:exchangeInfo="exchangeInfo"
				@back="this.mode = 'list'"
			></ExchangeDetailM>
		</div>
	</div>
</template>

<script>
import ExchangeDetailM from '@/components/User/Activity/ExchangeDetail.m.vue';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';
import pagination from '@/components/Pagination';
import { fetchDirectTransfers } from '@/api/market';
import Accordion from '@/components/Layout/Accordion.vue';
import AccordionItem2 from '@/components/Layout/AccordionItem2';
import '@/assets/css/activity.m.css';

export default {
	name: 'Exchange.m',
	components: { ExchangeDetailM, pagination, Accordion, AccordionItem2 },
	data() {
		return {
			selectedTab: 'ALL',
			accountTransferList: [],
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			assetSeq: null,
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			mode: 'list',
			exchangeInfo: {},
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	watch: {
		selectedTab() {
			this.loadDirectTransferList('pageInit');
		},
		startDate() {
			this.loadDirectTransferList('pageInit');
		},
		endDate() {
			this.loadDirectTransferList('pageInit');
		},
		mode() {
			window.scrollTo(0, 0);
		},
	},
	created() {
		this.assetSeq = this.$route.query.asset_seq || null;
		this.init();
	},
	methods: {
		init() {
			this.loadDirectTransferList();
		},
		async loadDirectTransferList(type) {
			if (type === 'pageInit') {
				this.curPage = 1;
			}
			const params = {
				source_asset_seq: this.assetSeq,
				transfer_type: this.selectedTab === 'ALL' ? null : this.selectedTab,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchDirectTransfers(
				params,
			).catch(commonError);
			this.accountTransferList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDirectTransferList();
		},
		showDetail(info) {
			this.exchangeInfo = info;
			this.mode = 'detail';
		},
	},
};
</script>
